<template>
  <div class="TheFooterLinks">
    <div class="TheFooterLinks__logos">
      <div class="TheFooterLinks__logo-sustainalyse-container">
        <img
          class="TheFooterLinks__logo-sustainalyse"
          src="/images/sustainalyse-logo-light.svg"
          alt="Sustainalyse logo"
        />

        <p class="TheFooterLinks__logo-sustainalyse-text">
          Measure what matters. Improve your impact.
        </p>
      </div>

      <div class="TheFooterLinks__logo-certifications-container">
        <img
          src="../../assets/bcorp.svg"
          height="100"
          alt="B Corp logo"
          loading="lazy"
        />
        <img
          src="../../assets/efrag.svg"
          height="100"
          alt="EFRAG logo"
          loading="lazy"
        />
      </div>
    </div>

    <div class="TheFooterLinks__links">
      <div
        class="TheFooterLinks__links-column"
        v-for="link in links"
        :key="link.label"
      >
        <h3 class="TheFooterLinks__links-title">{{ link.label }}</h3>
        <ul class="TheFooterLinks__links-list">
          <li
            class="TheFooterLinks__links-item"
            v-for="sublink in link.links"
            :key="sublink.label"
          >
            <a
              v-if="sublink?.href"
              :href="sublink.href"
              target="_blank"
              class="TheFooterLinks__links-link"
            >
              {{ sublink.label }}
            </a>
            <RouterLink
              v-else-if="sublink.to"
              class="TheFooterLinks__links-link"
              :to="sublink.to"
            >
              {{ sublink.label }}
            </RouterLink>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { RouteLocationRaw } from 'vue-router'

export interface IFooterLink {
  label: string
  links: {
    label: string
    href?: string
    to?: RouteLocationRaw
  }[]
}

const links: IFooterLink[] = [
  {
    label: 'Product',
    links: [
      {
        label: 'Features',
        to: { name: 'Landing', hash: '#SectionFeatureList' },
      },
      // {
      //   label: 'Solutions',
      //   to: { name: 'Landing', hash: '#SectionFeatureList' },
      // },
      {
        label: 'Pricing',
        to: { name: 'CarbonAccounting', hash: '#SectionPlanCompare' },
      },
    ],
  },
  {
    label: 'Company',
    links: [
      {
        label: 'About us',
        to: { path: '/about' },
      },
      {
        label: 'Careers',
        to: { path: '/job-openings' },
      },
      {
        label: 'Contact',
        to: { name: 'Contact' },
      },
    ],
  },
  {
    label: 'Legal',
    links: [
      {
        label: 'Privacy',
        to: { path: '/privacy-policy' },
      },
      {
        label: 'Status',
        href: 'https://sustainalyse.hyperping.app/',
      },
    ],
  },
]
</script>

<style lang="scss" scoped>
.TheFooterLinks {
  color: $color-ui-brand-200;
  display: flex;
  gap: 2rem;
  justify-content: space-between;
  flex-direction: column;
  padding-bottom: 1.75rem;
  border-bottom: 1px solid $color-ui-brand-600;
  margin-bottom: 2rem;

  @include md {
    gap: 4rem;
    flex-direction: row;
  }

  .TheFooterLinks__logos {
    @include md {
      max-width: 20rem;
    }
  }

  .TheFooterLinks__logo-sustainalyse {
    display: block;
  }

  .TheFooterLinks__logo-sustainalyse-text {
    color: $color-ui-brand-200;
    margin-top: 1rem;
  }

  .TheFooterLinks__logo-certifications-container {
    margin-top: 2.875rem;
    display: flex;
    gap: 1.5rem;
    justify-content: space-between;

    @include md {
      justify-content: flex-start;
    }
  }

  .TheFooterLinks__links {
    display: grid;
    gap: 1.25rem;
    grid-template-columns: repeat(2, 1fr);

    @include md {
      grid-template-columns: repeat(4, 10rem);
    }
  }

  .TheFooterLinks__links-title {
    @include font-size-16px();
    color: $color-ui-brand-300;
    margin-bottom: 1rem;
  }

  .TheFooterLinks__links-list {
    list-style: none;
    display: grid;
    grid-template-columns: 1fr;
    gap: 0.75rem;
  }

  .TheFooterLinks__links-link {
    color: $color-ui-brand-200;
    font-weight: 600;
    text-decoration: none;

    &:hover {
      color: $color-white;
    }
  }
}
</style>
